import { Component, OnChanges, OnDestroy, OnInit, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HelpText } from '../../model/help-text';
import { LocalDate } from '../../model/local-date';
import { LanguageService } from '../../service/language.service';

/** @deprecated Use a readonly `astral-input` in new or Astralized templates. */
@Component({
    selector: 'app-text-box-readonly',
    templateUrl: './text-box-readonly.component.html',
    styleUrls: ['./text-box-readonly.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextBoxReadonlyComponent implements OnChanges, OnDestroy, OnInit {
  constructor(
    private _router: Router,
    private _languageService: LanguageService
  ) {
    this._languageSubscription = this._languageService.onLangChange
      .subscribe(() => {
        if (this.caption)
          this.placeholderText = this._languageService.instant(this.caption);

        this.updateValue(this.text);
      });
  }

  @Input() caption: string;
  @Input() helpText: string | HelpText;
  // Read-only display field: callers pass strings, numbers (e.g. surface area)
  // and LocalDate values, all rendered via interpolation.
  @Input() text: string | number | LocalDate | null | undefined;
  @Input() translateText: boolean;
  @Input() fieldType: string = '';

  private _languageSubscription: Subscription;
  placeholderText: string;
  value: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['caption']) {
      this.placeholderText = this._languageService.instant(changes['caption'].currentValue);
    }

    if (changes['text']) this.updateValue(changes['text'].currentValue);
  }

  ngOnDestroy(): void {
    if (this._languageSubscription) this._languageSubscription.unsubscribe();
  }

  ngOnInit() {
    this.placeholderText = this._languageService.instant(this.caption);
    this.updateValue(this.text);
  }

  private updateValue(text: string | number | LocalDate | null | undefined): void {
    if (text == null) {
      this.value = '';
      return;
    }

    this.value = this.translateText ? this._languageService.instant(text as string) : `${text}`;
  }

  sendEmail() {
    // console.log('Email sending...');
    // const command = this._commandFactory.createMultiselectCommand('sendTenantEmail', [{emailReceivers:this.value}], [{emailReceivers:this.value}]);
    // this._commandDispatcher.sendCommand(command);
    this._router.navigateByUrl('/dh/email/send-generic?tmpusr=' + encodeURIComponent(this.value));
  }
}
